import { makeSelector, EnhancedSelector } from '@taskworld.com/rereselect';

// based of  https://github.com/taskworld/rereselect#parameterized-selectors

interface NamedSelector<S, R> extends EnhancedSelector<S, R> {
  displayName?: string;
}

const index = {};
const MAX_CACHE_ENTRIES = 1000;

export function makeParameterizedSelector(
  displayName,
  selectionLogicGenerator,
  makeKey = (...args) => args.join(',')
) {
  // cache
  const memoized = new Map();

  // selector function, Object.assign is used to add the displayName for adding to global index for debug purposes
  const selectorFactory = Object.assign(
    // actual function
    function (...args) {
      // serialize args into a cache key
      const key = makeKey(...args);

      // check cache
      if (memoized.has(key)) return memoized.get(key);


      // generate the selector
      const selectionLogic = selectionLogicGenerator(...args);
      const selector: NamedSelector<any, unknown> = makeSelector(
        selectionLogic
      );

      // add name to selector for debug purposes
      const name = `${displayName}(${key})`;
      selector.displayName = name;

      // add to cache
      memoized.set(key, selector);

      if (memoized.size > MAX_CACHE_ENTRIES) {
        // TODO: prune cache?
        console.warn(
          `ParameterizedSelector cache for ${displayName} exceeds ${MAX_CACHE_ENTRIES} entries`
        );
      }
      return selector;
    },
    { displayName }
  );

  index[selectorFactory.displayName] = { selectorFactory, memoized };
  return selectorFactory;
}

window['_selectorIndex'] = index;
